<template>
  <div>
    <CCard>
      <ul class="nav nav-tabs">
        <li class="nav-item" v-if="view === 'analise'">
          <a class="nav-link active" @click="changeView('analise')">ANALISIS</a>
        </li>
        <li class="nav-item" v-else>
          <a class="nav-link" @click="changeView('analise')">ANALISIS</a>
        </li>
        <li class="nav-item" v-if="view === 'respuestas'">
          <a class="nav-link active" @click="changeView('respuestas')"
            >RESPUESTAS
            <CBadge class="p-2" color="primary"
              >[{{ leftItem.length }}]</CBadge
            ></a
          >
        </li>
        <li class="nav-item" v-else>
          <a class="nav-link" @click="changeView('respuestas')"
            >RESPUESTAS
            <CBadge class="p-2" color="secondary"
              >[{{ leftItem.length }}]</CBadge
            >
          </a>
        </li>
      </ul>

      <CCardBody v-if="view === 'respuestas'">
        <CRow>
          <CCol class="col-md-6">
            <CRow class="pt-2 pb-3">
              <!-- <CCol sm="6">
                <multiselect
                  v-model="selecteddateFilter"
                  placeholder="fecha"
                  :options="fecha"
                  :close-on-select="true"
                  :clear-on-select="false"
                  @input="onChangedateFilter()"
                  :multiple="false"
                  :taggable="true"
                ></multiselect>
              </CCol>
              <CCol sm="6">
                <multiselect
                  v-model="selectquestionfilter"
                  placeholder="Proyecto"
                  :options="questionText"
                  :close-on-select="true"
                  :clear-on-select="false"
                  @input="onChangequestionFilter()"
                  :multiple="false"
                  :taggable="true"
                ></multiselect>
              </CCol> -->
              <CCol class="sm-12 ">
                <date-picker
                  style="width: 200px"
                  v-model="range"
                  range
                  confirm
                  placeholder="Cualquier fecha"
                  @change="onChangedateFilter(range)"
                ></date-picker>
              </CCol>
            </CRow>

            <!-- <CCard class="pt-2" style="height: overflow-y: auto;">
              <CCardHeader class="text-left p-2">
                <span class="col-2"
                  ><label class="form-checkbox">
                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @click="select"
                    />
                    <i class="form-icon"></i>
                  </label> </span
                ><span class="8"
                  ><strong
                    >{{ leftItem.length }} respuestas en total</strong
                  ></span
                >
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CListGroup class="col-md-12 p-1" name="respustas">
                    //  <semipolar-spinner
                    //   :animation-duration="2000"
                    //   :size="30"
                    //   color="blue"
                    //   v-if="isLoading"
                    // ></semipolar-spinner> 

                    <div class="message" v-if="leftItem.length === 0">
                      No Respuestas...
                    </div>
                    <CListGroupItem
                      href="#"
                      v-for="(item, index) in leftItem"
                      :key="index"
                      class="message col-sm-12 p-2 text-lef border-bottom"
                      @click="getAnswerData(item)"
                    >
                    //    @click="getdataonrowclick(item)" 
                    //    v-if="!isLoading" 
                      <div v-if="leftItem.length > 0">
                        <div>
                          <span class="col-2">
                            <label class="form-checkbox">
                              <input
                                type="checkbox"
                                :value="item.id"
                                v-model="selected_checked"
                                @click="getCheckboxData(item)"
                              />
                              <i class="form-icon"></i>
                            </label>
                          </span>
                        //    <td>{{i.id}}</td>
                          <span class="col-5">{{
                            item.create_date | formatDateonly
                          }}</span>
                          <span class="col-5">{{ item.uuid }}</span>
                        </div>
                      </div>
                    </CListGroupItem>
                  </CListGroup>
                </CRow>
              </CCardBody>
            </CCard>
             -->

            <!-- <table class="table table-striped table-hover" filter>
              <thead>
                <tr>
                  <th>
                    <label class="form-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectAll"
                        @click="selectnew"
                      />
                      <i class="form-icon"></i>
                    </label>
                  </th>
                  <th>{{ chackboxTable.length }} respuestas en total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i, key) in chackboxTable" :key="key">
                  <td>
                    <label class="form-checkbox">
                      <input
                        type="checkbox"
                        :value="i.id"
                        v-model="selected_checked"
                        @click="getAnswerData(i)"
                      />
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td @click="getdataonrowclick(i)">
                    {{ i.create_date | formatDateonly }}
                  </td>
                  <td @click="getdataonrowclick(i)">{{ i.uuid }}</td>
                </tr>
              </tbody>
            </table> -->

            <!--New Code For Checkbox Table -->
            <table class="table table-hover" filter>
              <thead>
                <tr>
                  <th>
                    <label class="form-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectAll"
                        @change="toggleAllData($event)"
                      />
                      <i class="form-icon"></i>
                    </label>
                  </th>
                  <th>{{ leftItem.length }} respuestas en total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(i, index) in leftItem"
                  :key="index"
                  :class="i.isSelected || i.isChecked ? 'active' : 'inactive'"
                >
                  <td>
                    <label class="form-checkbox">
                      <input
                        type="checkbox"
                        :checked="i.isChecked"
                        :value="i.id"
                        @change="getCheckboxData($event, i)"
                      />

                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td @click="getAnswerData(i)">
                    {{ i.create_date | formatDateonly }}
                  </td>
                  <td @click="getAnswerData(i)">{{ i.uuid }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="isSelectedCount > 0">
              <CRow class="m-2">
                <h5 class="mt-2">[{{ isSelectedCount }}] Seleccionadas</h5>

                <CButton class="ml-2" color="light">
                  <download-csv :data="verifySelectedData">
                    Descargar
                  </download-csv>
                </CButton>

                <CButton class="ml-2" color="danger" @click="respustasDelete"
                  >Eleminar</CButton
                >
              </CRow>
            </div>
            <div v-else>
              <CButton color="success">Descargar todas las respuestas</CButton>
            </div>
          </CCol>

          <CCol class="col-md-6">
             <CRow class="pt-2 mb-4">
              <CCol sm="6">
                <date-picker
                  style="width: 200px"
                  v-model="range_ans"
                  range
                  confirm
                  placeholder="Cualquier fecha"
                  @change="dateSelected(range_ans)"
                ></date-picker>
              </CCol>
<!--
              <CCol sm="6">
                <multiselect
                  v-model="select_buscar_respuestas"
                  placeholder="Buscar Respuestas Search"
                  :options="buscar_respuestas_search"
                  :close-on-select="true"
                  :clear-on-select="false"
                  @input="onChange_buscar_respuestas()"
                  :multiple="false"
                  :taggable="true"
                ></multiselect>
              </CCol>-->
            </CRow> 

            <CCard class="p-3">
              <div class="ml-3">
                <!-- 1 oct, 2017 9:55 -->
                <div
                  class="text-right ml-5"
                  v-if="verifySelectedData.length > 0"
                >
                  <CButton>
                    <download-csv :data="verifySelectedData" >
                      <i class="fas fa-download"></i>
                    </download-csv>
                  </CButton>
                  <CButton @click="respustasDelete" ><!-- @click="warningModal = true" -->
                    <i class="fa fa-trash ml-3" aria-hidden="true"></i>
                  </CButton>
                </div>
                <CModal title="Action" color="warning" @click="respustasDelete" :show.sync="warningModal"
                  >Are You Sure want to delete</CModal
                >
                <div
                  class="text-right ml-5"
                  v-if="selecteduuids.length == 0"
                >
                  <strong>Plese select checkbox </strong>
                </div>
                <div
                  class="ml-5"
                  v-if="selecteduuids.length !== 0 && verifySelectedData.length == 0"
                >
                  <strong>No Data. </strong>
                </div>
              </div>
              <!-- <div v-if="rightItems.length > 0">
                <div v-for="(i, key) in rightItems" :key="key">
                  <CCol class="mt-5" v-if="i.question_text">
                    <CRow>
                      <CButton color="warning">
                        <i class="fas fa fa-th"></i>
                        {{ key }}
                      </CButton>
                      <div class="ml-3">{{ i.question_text }}</div>
                    </CRow>
                    <CCol>
                      <div class="ml-5">{{ i.answer }}</div>
                    </CCol>
                  </CCol>
                </div>
              </div> -->
              <div v-if="verifySelectedData.length > 0">
                <div v-for="(i, key) in verifySelectedData" :key="key">
                  <CCard
                    class="m-2 mt-5 pl-2 pb-2 pr-1 pt-2"
                    v-if="i.question_text"
                  >
                    <CHeader>{{ getDate(i.create_date) }} </CHeader>
                    <CCol class="mt-2">
                      <CRow>
                        <CButton color="warning">
                          <i class="fas fa fa-th"></i>
                          {{ key }}
                        </CButton>
                        <div class="ml-3">{{ i.question_text }}</div>
                      </CRow>
                      <CCol>
                        <div class="ml-5">{{ i.answer }}</div>
                      </CCol>
                    </CCol>
                  </CCard>
                  <!-- <CCard v-else class="m-3 pt-3 mt-5">
                    <CHeader class="m-3 pt-3 mt-3" align="center"
                      >No Data Available for
                      <b> {{ i.uuid }} </b>
                    </CHeader>
                  </CCard> -->
                </div>
              </div>
              <!-- <CCol class="mt-5">
                <CRow>
                  <CButton color="info">
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                    2
                  </CButton>
                  <div class="ml-3">? tu correo ,pilar aranda</div>
                </CRow>
                <CCol>
                  <div class="ml-5">ipatri@hotmail.com</div>
                </CCol>
              </CCol>
              <CCol class="mt-5">
                <CRow>
                  <CButton color="danger">
                    <i class="fas fa fa-align-justify"></i>
                    2
                  </CButton>
                  <div class="ml-3">iahora sii, Cuentanos tu experiencia con datelle;)</div>
                </CRow>
                <CCol>
                  <div class="ml-5">Un papel que no traspasa la tinta, siempre hace un gran papel un</div>
                </CCol>
              </CCol>-->
            </CCard>
          </CCol>
        </CRow>
      </CCardBody>

      <CCardBody v-else>
        <CCol class="mt-4 mb-4">
          <h4>Información general</h4>
        </CCol>
        <!-- 
        <CRow class="mt-4 col-md-12">
          <Ccol class="col-md-3">
            <h6>comenzados</h6>
            <div style="fontSize:30px;">{{comenzados}}</div>
          </Ccol>
          <Ccol class="col-md-3">
            <h6>Respuestas</h6>
            <div style="fontSize:30px;">{{respuestas}}</div>
          </Ccol>
          <Ccol class="col-md-3">
            <h6>Completados</h6>
            <div style="fontSize:30px;">{{completados}}</div>
          </Ccol>
          <Ccol class="col-md-3">
            <h6>Tiempo media para completar</h6>
            <div style="fontSize:30px;">{{tiempo_media_para_completar}}</div>
          </Ccol>
        </CRow> -->

        <!-- <CCol class="mt-4 mb-4">
          <h4>Metricas de promocion</h4>
        </CCol> -->

        <!-- <AnswerWidget :value1="comenzados" :value2="respuestas" :value3="completados" value4="400" /> -->

        <!--Widgets -->
        <CRow>
          <CCol sm="6" lg="3">
              <!-- color="primary" -->
            <CWidgetDropdown
              :header="comenzados"
              text="Comenzados"
              style="background-color: #7c7c7c;"
            ><div style="height:100px">&nbsp;</div>
               <!-- <template #footer>
                <CChartLineSimple
                  pointed
                  class="mt-3 mx-3"
                  style="height: 70px; color:white; width:2"
                  :data-points="[65, 59, 84, 84, 51, 55, 40]"
                  point-hover-background-color="danger"
                  label="Members"
                  labels="months"
                />
              </template>  -->
            </CWidgetDropdown>
          </CCol>
          <CCol sm="6" lg="3">
              <!-- color="info" -->
            <CWidgetDropdown
              :header="respuestas"
              text="Respuestas"
              style="background-color: #7c7c7c;"
            ><div style="height:100px">&nbsp;</div>
            <!--  <template #footer>
                <CChartLineSimple
                  pointed
                  class="mt-3 mx-3"
                  style="height: 70px; borderColor:#3d3d3d;"
                  :data-points="[1, 18, 9, 17, 34, 22, 11]"
                  :options="{ elements: { line: { borderWidth: 2.5 } } }"
                  point-hover-background-color="light"
                  label="Members"
                  labels="months"
                />
              </template> -->
            </CWidgetDropdown>
          </CCol>
          <CCol sm="6" lg="3">
              <!-- color="warning" -->
            <CWidgetDropdown
              :header="completados"
              text="Completados"
              style="background-color: #7c7c7c;"
            >
            <div style="height:100px">&nbsp;</div>
              <!-- <template #footer>
                <CChartLineSimple
                  class="mt-3"
                  style="height: 70px"
                  background-color="rgba(255,255,255,.2)"
                  :data-points="[78, 81, 80, 45, 34, 12, 40]"
                  :options="{ elements: { line: { borderWidth: 2.5 } } }"
                  point-hover-background-color="warning"
                  label="Members"
                  labels="months"
                />
              </template> -->
            </CWidgetDropdown>
          </CCol>
          <CCol sm="6" lg="3">
              <!-- color="danger" -->
            <CWidgetDropdown
              :header="tiempo_media_para_completar"
              text="Tiempo medio para completar"
              style="fontsize: 10px; background-color: #7c7c7c;"
            >
            <div style="height:100px">&nbsp;</div>
             <!--  <template #footer>
                <CChartBarSimple
                  class="mt-3 mx-3"
                  style="height: 70px"
                  background-color="rgb(250, 152, 152)"
                  label="Members"
                  labels="months"
                />
              </template> -->
            </CWidgetDropdown>
          </CCol>
        </CRow>
        <!--Widgets here -->

        <CCard>
          <CCardBody>
            <CRow>
              <CCol sm="5">
                <h4 id="traffic" class="card-title mb-0">ESTADÍSTICAS</h4>
                <!-- <div class="small text-muted">November 2017</div> -->
              </CCol>
              <CCol sm="7" class="d-none d-md-block">
                <CButton color="primary" class="float-right">
                  <CIcon name="cil-cloud-download" />
                </CButton>
                <CButtonGroup class="float-right mr-3">
                  <CButton
                    color="outline-secondary"
                    v-for="(value, key) in ['Day', 'Month', 'Year']"
                    :key="key"
                    class="mx-0"
                    :pressed="value === selected ? true : false"
                    @click="getchartdata(value)"
                    >{{ value }}</CButton
                  >
                </CButtonGroup>
              </CCol>
            </CRow>
            <!-- <MainChartExample style="height:300px;margin-top:40px;" /> -->
            <CChartLine
              style="height: 400px; margin-top: 40px"
              :datasets="renderedStatData"
              :options="defaultOptions"
              :labels="quizstatlables"
            />
          </CCardBody>
          <CCardFooter>
            <CRow class="text-center">
              <CCol md sm="12" class="mb-sm-2 mb-0">
                <div class="text-muted">Comenzados</div>
                <strong>{{ commenzados_graph }} </strong>
                <!-- <strong>{{ comenzados }} </strong> -->
                <CProgress
                  class="progress-xs mt-2"
                  :precision="1"
                  style="color:#eeeeee !important;"
                  :value="40"
                />
              </CCol>
              <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
                <div class="text-muted">Respuestas</div>
                <!-- <strong>{{ respuestas }}</strong> -->
                <strong>{{ respustas_graph }}</strong>
                <CProgress
                  class="progress-xs mt-2"
                  :precision="1"
                  color="info"
                  :value="40"
                />
              </CCol>
              <CCol md sm="12" class="mb-sm-2 mb-0">
                <div class="text-muted">Completados</div>
                <!-- <strong>{{ completados }}</strong> -->
                <strong>{{ completedos_graph }}</strong>
                <CProgress
                  class="progress-xs mt-2"
                  :precision="1"
                  color="warning"
                  :value="20"
                />
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MainChartExample from "../../charts/MainChartExample";
import { CChartLine } from "@coreui/vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils/src";
// import AnswerWidget from "../../widgets/AnswerWidget";
import WidgetsBrand from "../../widgets/WidgetsBrand";
import { CChartLineSimple, CChartBarSimple } from "../../charts/index.js";
// import {VueBlobJsonCsv} from 'vue-blob-json-csv';

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";
import store from "../../../store";
import moment from "moment";

const items = [
  { username: "Samppa Nori", Fecha: "2012/01/01" },
  { username: "Estavan Lykos", Fecha: "2012/02/01" },
  { username: "Chetan Mohamed", Fecha: "2012/02/01" },
  { username: "Derick Maximinus", Fecha: "2012/03/01" },
  { username: "Friderik Dávid", Fecha: "2012/01/21" },
  { username: "Yiorgos Avraamu", Fecha: "2012/01/01" },
  { username: "Avram Tarasios", Fecha: "2012/02/01" },
  { username: "Quintin Ed", Fecha: "2012/02/01" },
  { username: "Enéas Kwadwo", Fecha: "2012/03/01" },
  { username: "Agapetus Tadeáš", Fecha: "2012/01/21" },
  { username: "Carwyn Fachtna", Fecha: "2012/01/01" },
  { username: "Nehemiah Tatius", Fecha: "2012/02/01" },
  { username: "Ebbe Gemariah", Fecha: "2012/02/01" },
  { username: "Eustorgios Amulius", Fecha: "2012/03/01" },
  { username: "Leopold Gáspár", Fecha: "2012/01/21" },
  { username: "Pompeius René", Fecha: "2012/01/01" },
  { username: "Paĉjo Jadon", Fecha: "2012/02/01" },
  { username: "Micheal Mercurius", Fecha: "2012/02/01" },
  { username: "Ganesha Dubhghall", Fecha: "2012/03/01" },
  { username: "Hiroto Šimun", Fecha: "2012/01/21" },
  { username: "Vishnu Serghei", Fecha: "2012/01/01" },
  { username: "Zbyněk Phoibos", Fecha: "2012/02/01" },
  { username: "Einar Randall", Fecha: "2012/02/01" },
  { username: "Félix Troels", Fecha: "2012/03/21" },
  { username: "Aulus Agmundr", Fecha: "2012/01/01" },
];
const fields = ["Fecha", { key: "username", _style: "min-width:200px" }];
function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default {
  name: "AdvancedTables",
  props: ["itemID"],
  computed: {
    defaultDatasets() {
      const brandSuccess = getStyle("success2") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";

      let elements = 27;
      const data1 = [];
      const data2 = [];
      const data3 = [];

      for (let i = 0; i <= elements; i++) {
        data1.push(random(50, 200));
        data2.push(random(80, 100));
        data3.push(65);
      }
      console.log("data1", data1);
      console.log("data2", data2);
      console.log("data3", data3);
      return [
        {
          label: "My First dataset",
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: data1,
        },
        {
          label: "My Second dataset",
          backgroundColor: "transparent",
          borderColor: brandSuccess,
          pointHoverBackgroundColor: brandSuccess,
          borderWidth: 2,
          data: data2,
        },
        {
          label: "My Third dataset",
          backgroundColor: "transparent",
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 1,
          borderDash: [8, 5],
          data: data3,
        },
      ];
    },
    defaultOptions() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 50,
                stepSize: 10,
                
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
          },
        },
      };
    },
  },
  components: {
    MainChartExample,
    // AnswerWidget,
    WidgetsBrand,
    DatePicker,
    Multiselect,
    CChartLineSimple,
    CChartBarSimple,
    CChartLine,
    // VueBlobJsonCsv
  },
   updated(){
    //console.log("CONSOLE LOG IMPORTANTE",store.getters.getstatOverview)
  }
  ,
  data() {
    return {
      warningModal: false,
      date: "",
      time: "",
      range: "",
      range_ans: "",
      isLoading: false,
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.range = [today, today];
          },
        },
        {
          text: "YesterDay",
          onClick: () => {
            this.range = [yesterday, yesterday];
          },
        },
        {
          text: "Last 7 Days",
          onClick: () => {
            this.range = [last7days, last7days];
          },
        },
        {
          text: "Last Month",
          onClick: () => {
            this.range = [lastmonth, lastmonth];
          },
        },
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:30",
        end: "23:30",
      },
      view: "analise",
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      fields,
      details: [],
      collapseDuration: 0,
      selected: "Day",
      tableItems: [
        {
          avatar: { url: "img/avatars/1.jpg", status: "success" },
          user: {
            name: "Yiorgos Avraamu",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "USA", flag: "cif-us" },
          usage: { value: 50, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Mastercard", icon: "cib-cc-mastercard" },
          activity: "10 sec ago",
        },
        {
          avatar: { url: "img/avatars/2.jpg", status: "danger" },
          user: {
            name: "Avram Tarasios",
            new: false,
            registered: "Jan 1, 2015",
          },
          country: { name: "Brazil", flag: "cif-br" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Visa", icon: "cib-cc-visa" },
          activity: "5 minutes ago",
        },
        {
          avatar: { url: "img/avatars/3.jpg", status: "warning" },
          user: { name: "Quintin Ed", new: true, registered: "Jan 1, 2015" },
          country: { name: "India", flag: "cif-in" },
          usage: { value: 74, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Stripe", icon: "cib-stripe" },
          activity: "1 hour ago",
        },
        {
          avatar: { url: "img/avatars/4.jpg", status: "" },
          user: { name: "Enéas Kwadwo", new: true, registered: "Jan 1, 2015" },
          country: { name: "France", flag: "cif-fr" },
          usage: { value: 98, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "PayPal", icon: "cib-paypal" },
          activity: "Last month",
        },
        {
          avatar: { url: "img/avatars/5.jpg", status: "success" },
          user: {
            name: "Agapetus Tadeáš",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "Spain", flag: "cif-es" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Google Wallet", icon: "cib-google-pay" },
          activity: "Last week",
        },
        {
          avatar: { url: "img/avatars/6.jpg", status: "danger" },
          user: {
            name: "Friderik Dávid",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "Poland", flag: "cif-pl" },
          usage: { value: 43, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Amex", icon: "cib-cc-amex" },
          activity: "Last week",
        },
      ],
      tableFields: [
        { key: "avatar", label: "", _classes: "text-center" },
        { key: "user" },
        { key: "country", _classes: "text-center" },
        { key: "usage" },
        { key: "payment", label: "Payment method", _classes: "text-center" },
        { key: "activity" },
      ],
      items_table: [
        { id: "1", username: "Samppa Nori", Fecha: "2012/01/01" },
        { id: "2", username: "Estavan Lykos", Fecha: "2012/02/01" },
        { id: "3", username: "Chetan Mohamed", Fecha: "2012/02/01" },
        { id: "4", username: "Derick Maximinus", Fecha: "2012/03/01" },
        { id: "5", username: "Friderik Dávid", Fecha: "2012/01/21" },
        { id: "6", username: "Yiorgos Avraamu", Fecha: "2012/01/01" },
        { id: "7", username: "Avram Tarasios", Fecha: "2012/02/01" },
        { id: "8", username: "Quintin Ed", Fecha: "2012/02/01" },
      ],
      selected_checked: [],
      selecteduuids: [],
      selected_ques_id: [],
      selectAll: false,
      isSelected: [],
      isSelectedCount: 0,
      comenzados: "0",
      respuestas: "0",
      completados: "0",
      tiempo_media_para_completar: "18:25",
      item_match: [],
      fecha: [],
      questionText: [],
      chackboxTable: [],
      tempItemMatch: [],
      uuid: [],
      buscar_respuestas_search: [],
      selecteddateFilter: "",
      selectuidfilter: "",
      selectquestionfilter: "",
      rightItems: [],
      rightfiltered_data: [],
      rightItemsArray: [],
      select_buscar_respuestas: [],
      leftItem: [],
      leftItemCount: [],
      quizstatData: [],
      quizstatData_month: [],
      quizstatData_year: [],
      renderedStatData: [],
      quizstatlables: [],
      graphdatabyQuiz: [],
      isDataFromRow: false,
      verifySelectedData:[],
      commenzados_graph:0,
      respustas_graph:0,
      completedos_graph:0,
    };
  },
  async mounted() {
    // await this.getstatIds();
    // await this.getQuizes();
    // await this.getQuizstatOverview();

    await this.getcommenzadosCount();
    await this.getRespustasCount();
    await this.getCompletadosCount();
    await this.getparaCompletar();
    await this.getGraphdatabyQuiz();
    await this.getRespustasData();
    await this.getstatOverview();
    await this.getstatOverviewMonth();
    await this.getstatOverviewYear();
    
    //this.getCampaignAdset()
  },
  methods: {
    getQuizDataByMonth(data) {
      const brandSuccess = getStyle("success2") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";
      let currentMonthData = [];
      let currentDate = new Date();//"2021-02-08 00:00:00"
      // let currentDate = moment().subtract(2,"months");
      let labels = [];
      // console.log("currentDate ", currentDate);
      var max = currentDate.getDate();
      data.forEach((d) => {
        if (new Date(d.create_date).getMonth() == currentDate.getMonth()) {
          currentMonthData.push({ ...d });
        }
      });

      let startedList = [];
      let  answersList = [];
      let  finishedList = [];

        var started_sum = 0;
        var answer_sum = 0;
        var finished_sum = 0;
        
      for (let j = 1; j <= max; j++) {
        let startedAvg = 0,
          answerAvg = 0,
          finishedAvg = 0,
          count = 0;
        labels.push(j);
        for (let i = 0; i < currentMonthData.length; i++) {
          if (new Date(currentMonthData[i].create_date).getDate() == j) {
            count++;
            startedAvg += currentMonthData[i].started;
            answerAvg += currentMonthData[i].answers;
            finishedAvg += currentMonthData[i].finished;
          }
        }
        count = count == 0 ? 1 : count;
        started_sum += startedAvg;
        answer_sum += answerAvg;
        finished_sum += finishedAvg;
        
        startedList.push(startedAvg / count);
        answersList.push(answerAvg / count);
        finishedList.push(finishedAvg / count);
      }
      this.commenzados_graph=started_sum;
      this.respustas_graph=answer_sum;
      this.completedos_graph=finished_sum;

      //console.log("finishedList", finishedList);
      this.quizstatlables = labels.map(
        (l) => l.toString() + "-" + this.getMonthText(new Date().getMonth() + 1)
      );

      return [
        {
          label: "Started",
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: startedList,
        },
        {
          label: "Answers",
          backgroundColor: "transparent",
          borderColor: brandSuccess,
          pointHoverBackgroundColor: brandSuccess,
          borderWidth: 2,
          data: answersList,
        },
        {
          label: "Finished",
          backgroundColor: "transparent",
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 2,
          borderDash: [8, 5],
          data: finishedList,
        },
      ];
    },
    getQuizDataByDay(data) {
      const brandSuccess = getStyle("success2") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";
      let currentDayData = [];
      let currentDate = new Date();//"2020-11-10 00:00:00"
      //console.log("date today==>", currentDate);
      let labels = [],
        max = currentDate.getHours();
      data.forEach((d) => {
        //console.log("data d", d.create_date, currentDate);
        if (
          new Date(d.create_date).toDateString() == currentDate.toDateString()
        ) {
          if (new Date(d.create_date).getDate() == currentDate.getDate()) {
            currentDayData.push({ ...d });
          }
        }
      });
      //console.log("currentDayData==>", currentDayData, max);

      let startedList = [],
        answersList = [],
        finishedList = [];

        var started_sum = 0;
        var answer_sum = 0;
        var finished_sum = 0;
      for (let j = 1; j <= max; j++) {
        let startedAvg = 0,
          answerAvg = 0,
          finishedAvg = 0,
          count = 0;
        labels.push(j);
        for (let i = 0; i < currentDayData.length; i++) {
          if (new Date(currentDayData[i].create_date).getHours() == j - 1) {
            count++;
            startedAvg += currentDayData[i].started;
            answerAvg += currentDayData[i].answers;
            finishedAvg += currentDayData[i].finished;
          }
        }
        count = count == 0 ? 1 : count;
        started_sum += startedAvg;
        answer_sum += answerAvg;
        finished_sum += finishedAvg;
        
        startedList.push(startedAvg / count);
        answersList.push(answerAvg / count);
        finishedList.push(finishedAvg / count);
      }
      this.commenzados_graph=started_sum;
      this.respustas_graph=answer_sum;
      this.completedos_graph=finished_sum;

      this.quizstatlables = labels.map((l) => this.getTimeFormat(l));

      return [
        {
          label: "Started",
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: startedList,
        },
        {
          label: "Answers",
          backgroundColor: "transparent",
          borderColor: brandSuccess,
          pointHoverBackgroundColor: brandSuccess,
          borderWidth: 2,
          data: answersList,
        },
        {
          label: "Finished",
          backgroundColor: "transparent",
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 1,
          borderDash: [8, 5],
          data: finishedList,
        },
      ];
    },
    getQuizDataByYear(data) {
      const brandSuccess = getStyle("success2") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";
      let currentYearData = [];
      // let currentDate = new Date();
      let currentDate = moment();//.subtract(1,'months')
      let labels = [];
      let  max = currentDate.month() + 1;
      //console.log("data 1077:::", data, max);
      data.forEach((d) => {
        //console.log("Date(d.create_date).getFullYear()", d.create_date , moment(d.create_date, "YYYY-MM-DD hh:mm:ss").year());
        if (
          // new Date(d.create_date).getFullYear() == currentDate.getFullYear()
          moment(d.create_date, "YYYY-MM-DD hh:mm:ss").year() == moment(currentDate,"DD/MM/YYYY").format("YYYY")
        ) {
          //console.log("=>>>>>>>>>>", d);
          currentYearData.push({ ...d });
        }
      });

      let startedList = [],
        answersList = [],
        finishedList = [];

        var started_sum = 0;
        var answer_sum = 0;
        var finished_sum = 0;
        //console.log("currentYearData ", currentYearData, max);
      for (let j = 1; j <= max; j++) {
        let startedAvg = 0,
          answerAvg = 0,
          finishedAvg = 0,
          count = 0;

        labels.push(j);
        for (let i = 0; i < currentYearData.length; i++) {
          if (new Date(currentYearData[i].create_date).getMonth() + 1 == j) {
            count++;
            startedAvg += currentYearData[i].started;
            answerAvg += currentYearData[i].answers;
            finishedAvg += currentYearData[i].finished;
          }
        }
        count = count == 0 ? 1 : count;
        started_sum += startedAvg;
        answer_sum += answerAvg;
        finished_sum += finishedAvg;
        
        startedList.push(startedAvg / count);
        answersList.push(answerAvg / count);
        finishedList.push(finishedAvg / count);
      }

      this.commenzados_graph=started_sum;
      this.respustas_graph=answer_sum;
      this.completedos_graph=finished_sum;


      this.quizstatlables = labels.map((l) => this.getMonthText(l));
      //console.log(">>>>>>>>>>>", startedList)
      //console.log(">>>>>>>>>>>", answersList)
      //console.log(">>>>>>>>>>>", finishedList)
      return [
        {
          label: "Started",
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: startedList,
        },
        {
          label: "Answers",
          backgroundColor: "transparent",
          borderColor: brandSuccess,
          pointHoverBackgroundColor: brandSuccess,
          borderWidth: 2,
          data: answersList,
        },
        {
          label: "Finished",
          backgroundColor: "transparent",
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 1,
          borderDash: [8, 5],
          data: finishedList,
        },
      ];
    },
    deletequestion() {
      //console.log("in question delete");

    },

    respustasDelete() {
      // //console.log("In Delete", this.selected_ques_id);
      // var ques_selected = this.selected_ques_id;
      var ids_for_delete =[];
      this.verifySelectedData.forEach((answer)=>{
          ids_for_delete.push(answer.id);
      })
      //console.log("respustasAnswerData for delete ::: ",ids_for_delete);
      var uuids_selected = this.selecteduuids;
      var payload = {
        answers: ids_for_delete,
        // quiz_id: Number(this.$route.params.itemID),
      };
      //console.log("payload",payload);
      store.dispatch("respustasDelete", payload).then((res) => {
        this.warningModal=false;
        // var uuids = store.getters.getRespustasData;
        // this.leftItem = uuids;
        // this.leftItemArray = uuids;
        this.getRespustasData();
        this.getRespustasAnswerData();
        this.isSelectedCount = 0;
      });
    },
    getchartdata(value) {
      //console.log("Value selected ::::", value, this.quizstatData);
      //console.log("Value selected ::::", value, this.quizstatData_month);
      //console.log("Value selected ::::", value, this.quizstatData_year);
      this.selected = value;
      if (value === "Day") {
        this.renderedStatData = this.getQuizDataByDay(this.quizstatData);
      }
      if (value === "Month") {
        this.renderedStatData = this.getQuizDataByMonth(this.quizstatData_month);
      }

      if (value === "Year") {
        this.renderedStatData = this.getQuizDataByYear(this.quizstatData_year);
      }
    },

    getAnswerData(i) {
      const uuidValue = i.uuid;
      const ques_id = i.id;
      const quiz_id = i.quiz_id.id;

      this.leftItem.forEach((val) => {
        val.isChecked = false;
        if (val.quiz_id.id == quiz_id && val.uuid == uuidValue)
          val.isSelected = true;
        else val.isSelected = false;
      });
      this.selectAll=false;
      this.selecteduuids=[];
      this.selected_ques_id=[];
      this.selecteduuids.push(uuidValue);
      this.selected_ques_id.push(ques_id);
      this.isSelectedCount = this.selecteduuids.length;
      //console.log("this.selected_ques_id ::: ", this.selected_ques_id);
      const payload = { uuid: JSON.stringify(uuidValue), quiz_id: quiz_id };
      this.getRespustasAnswerData();
      // store.dispatch("getAnswerData", payload).then(async () => {
      //   let data = await store.getters.getAnswerData;
      //   data = data.map((e) => {
      //     return { quiz_id: quiz_id, ...e };
      //   });
      //   this.verifySelectedData = data;
      //   //console.log(" this.verifySelectedData ", this.verifySelectedData);
      // });
    },

    getCheckboxData(e, i) {
      //console.log("getCheckboxData value==>", i, "check", e.target.checked);
      var local = [];
      const uuidValue = i.uuid;
      var uuids=[];
      var question_ids=[];
      //console.log("this.selecteduuids :: ", this.selecteduuids);
      if (e.target.checked) {
      this.selecteduuids=[];
        local.push({ isCheck: e.target.checked, id: i });
        local.forEach((e) => {
          this.isSelected = e.isCheck ? e.isCheck : false;
          uuids.push(i.uuid);
          question_ids.push(i.id);
          //console.log("selected ids", question_ids);

        this.selected_ques_id.push(i.id);
        });
        //console.log("this.selected_ques_id ::: ", this.selected_ques_id);

      this.leftItem.forEach((i) => {
        if(i.isChecked)
            uuids.push(i.uuid);
        });
        this.selecteduuids=uuids;
        if(this.selecteduuids.length === this.leftItem.length)
          this.selectAll=true;

        // this.isSelectedCount++;
        this.isSelectedCount=this.selecteduuids.length;
      } else {
        // this.isSelected = false;
        this.isSelected=false;
        local.forEach((e) => {
          if (e.isSelected.length >= 1) this.isSelected = true;
          else this.isSelected = false;
        });
        //console.log("this.selecteduuids removed :: ", this.selecteduuids);
        this.selecteduuids.pop(i.uuid);
        this.selectAll=false;
        this.selected_ques_id.pop(i.id);
        //console.log("this.selecteduuids :::: ", this.selecteduuids);
        //console.log("this.selected_ques_id :::: ", this.selected_ques_id);
        // this.isSelectedCount--;
        this.isSelectedCount=this.selecteduuids.length;
      }

      i.isChecked = e.target.checked;

      this.leftItem.forEach((el) => {
        el.isSelected = el.isChecked ? el.isChecked : false;
      });

      // if (this.isDataFromRow) {
      //   this.verifySelectedData = [];
      // }
      const quiz_id = i.quiz_id.id;
      this.getRespustasAnswerData();
      // if (
      //   this.verifySelectedData.find(
      //     (v) => v.quiz_id == quiz_id && v.uuid === uuidValue
      //   )
      // ) {
      //   var test = this.verifySelectedData.find(
      //     (v) => v.quiz_id == quiz_id && v.uuid === uuidValue
      //   );
      //   while (test) {
      //     this.verifySelectedData.splice(
      //       this.verifySelectedData.indexOf(
      //         this.verifySelectedData.find(
      //           (v) => v.quiz_id == quiz_id && v.uuid === uuidValue
      //         )
      //       ),
      //       1
      //     );
      //     test = this.verifySelectedData.find(
      //       (v) => v.quiz_id == quiz_id && v.uuid == uuidValue
      //     );
      //   }
      //   return;
      // }
      // const payload = { uuid: JSON.stringify(uuidValue), quiz_id: quiz_id };

      // store.dispatch("getAnswerData", payload).then(async () => {
      //   var data = await store.getters.getAnswerData;
      //   data.forEach((e) => {
      //     this.verifySelectedData.push({
      //       quiz_id: quiz_id,
      //       ...e,
      //     });
      //   });
      //   // this.isDataFromRow = false;
      //   //console.log(
      //     " this.verifySelectedData checkbox ",
      //     this.verifySelectedData.length
      //   );
      // });
    },

    toggleAllData(e) {
      let uuids = [],
        question_ids=[],
        quiz_id = "";
      if (e.target.checked) {
        this.leftItem.forEach((el) => {
          el.isSelected = el.isChecked = true;
        });
        this.leftItem.forEach((i) => {
          uuids.push(i.uuid);
          question_ids.push(i.id);
          quiz_id = i.quiz_id.id;
        });
        let payload = {
          uuid: uuids,
          quiz_id: quiz_id,
        };
        // //console.log();
        this.isSelectedCount = uuids.length;
        this.selecteduuids = uuids;
        this.selected_ques_id = question_ids;
        //console.log("pay :::::::", payload, uuids.length);
        //console.log("this.selected_ques_id :::::::", this.selected_ques_id);
        this.getRespustasAnswerData();
        // store.dispatch("getAnswerData", payload).then(async () => {
        //   let data = await store.getters.getAnswerData;
        //   this.verifySelectedData = data.map((e) => {
        //     return { quiz_id: quiz_id, ...e };
        //   });
        //   //console.log(
        //     " this.verifySelectedData  toggle DAta",
        //     this.verifySelectedData
        //   );
        // });
      } else {
        this.leftItem.forEach((el) => {
          el.isSelected = el.isChecked = false;
          this.verifySelectedData = [];
          this.selected_ques_id = [];
          this.isSelectedCount = uuids.length;
        });
      }
    },

    async getstatIds() {
      const item_id = Number(this.$route.params.itemID);
      // //console.log(
      //   "Number(this.$route.params.itemID) ::::: ",
      //   Number(this.$route.params.itemID),
      //   store.getters.getQuizes
      // );
      var uuids = store.getters.getstatIds;
      if (uuids.length === 0) {
        this.isLoading = true;
        await store.dispatch("getstatIds", item_id).then(() => {
          uuids = store.getters.getstatIds;
          this.leftItem = uuids;
          this.leftItemArray = uuids;

          return;
        });
      } else {
        this.leftItem = uuids;
        this.leftItemArray = uuids;
      }
      //console.log("uuids :::::::::: ", uuids);
    },

    getdataonrowclick(t) {
      //console.log("getdataonrowclick=============>", t);
      this.getRespustasAnswerData();
        // if (!this.verifySelectedData.includes(t)) {
        //   // var array = [];
        //   // // .toDateString()
        //   // array.push(t);
        //   // var newArray = array.map((i) => {
        //   //   i.create_date = i.create_date.toDateString();
        //   // });
        //   this.verifySelectedData.push(t);
        //   //console.log(
        //     "getdataonrowclick=============>verifySelectedData",
        //     this.verifySelectedData
        //   );
        // }

        // var filtered_data = [];
        // var rightfiltered_data = [];
        // // this.leftItem.forEach((item)=>{
        // //     if(t.id === item.id){
        // //         filtered_data.push(item);
        // //     }
        // // });
        // // //console.log("=============>", t);
        // verifySelectedData.push(t);
        // var payload = {
        //   quiz_id: t.quiz_id.id,
        //   uuid: t.uuid,
        // };
        // var uuidResponse = [];
        // // store.dispatch("getuuidResponse", payload).then(() => {
        // //   uuidResponse = store.getters.getuuidResponse;
        // //   this.rightItem = uuidResponse;
        // //   // this.rightItemArray = uuidResponse;
        // //   //console.log("rightItems::: ", uuidResponse);
        // //   return;
        // // });

        // this.rightItem = this.verifySelectedData
      // filtered_data.forEach((data)=>{
      //   var newdata = {
      //     answer : data.answer,
      //     answerlist:data.answerlist,
      //     uuid: data.uuid,
      //     quiz_id:data.quiz_id.name,
      //     question_text:data.question_text,
      //     create_date:data.create_date
      //   };

      //   rightfiltered_data.push(newdata);

      // });
      // this.rightfiltered_data = rightfiltered_data;
      // //console.log("rightfiltered_data", rightfiltered_data);
      // this.rightItems=[];
      // this.rightItems=filtered_data;
      // //console.log("this.rightItems", this.rightItems);
    },
    getdata(t) {
      //console.log("item :::::::::: ", t, this.stat_ids, this.selected_checked);
      // //console.log("getdata=============>", t);
      var filtered_data = [];
      // //console.log("selected_checked.length", this.selected_checked.length);
      if (this.selected_checked.length > 0) {
        //console.log("in checkbox match");

        filtered_data = this.chackboxTable.filter((item, index) => {
          return this.selected_checked.includes(item.id);
        });
      } else {
        //console.log("in single match");
        this.chackboxTable.forEach((item) => {
          if (t.id === item.id) {
            filtered_data.push(item);
          }
        });
      }
      //console.log("filtered_data", filtered_data);
      var rightfiltered_data = [];
      filtered_data.forEach((data) => {
        var newdata = {
          answer: data.answer,
          answerlist: data.answerlist,
          uuid: data.uuid,
          quiz_id: data.quiz_id.name,
          question_text: data.question_text,
          create_date: data.create_date,
        };

        rightfiltered_data.push(newdata);
      });
      this.rightfiltered_data = rightfiltered_data;
      //console.log("rightfiltered_data", rightfiltered_data);
      this.rightItems = [];
      this.rightItems = filtered_data;
      //console.log("this.rightItems", this.rightItems);
    },
    changeView(type) {
      this.view = type;
    },
    select() {
      const item_id = Number(this.$route.params.itemID);
      //console.log("this.selected_checked", this.selected_checked, item_id);
      this.selected_checked = [];
      this.selecteduuids = [];
      var filtered_data = [];
      //console.log("!this.selectAll", !this.selectAll);
      if (!this.selectAll) {
        for (let i in this.leftItem) {
          this.selected_checked.push(this.leftItem[i].id);
          this.selecteduuids.push(this.leftItem[i].uuid);
          this.isSelected = true;
        }
      }
      // //console.log("selected_checked", this.selected_checked);
      var uuid_array = [];
      var quiz_ids = [];

      filtered_data = this.leftItem.filter((item, index) => {
        uuid_array.push(item.uuid);
        quiz_ids.push(item.quiz_id.id);
        return this.selected_checked.includes(item.id);
      });

      //console.log("uuid_array :::::::: ", uuid_array);
      var payload = {
        uuid: uuid_array,
        quiz_id: quiz_ids,
      };
      var uuidResponse = [];
      if (uuid_array.length > 0) {
        // this.isLoading = true;
        store.dispatch("getuuidResponse", payload).then(() => {
          uuidResponse = store.getters.getuuidResponse;
          this.rightItem = uuidResponse;
          this.rightItemArray = uuidResponse;
          //console.log("rightItems::: ", rightItems);
          return;
        });
      } else {
      }
      // //console.log("uuids :::::::::: ", uuids);

      var rightfiltered_data = [];
      filtered_data.forEach((data) => {
        var newdata = {
          // answer : data.answer,
          // answerlist:data.answerlist,
          uuid: data.uuid,
          // quiz_id:data.quiz_id.name,
          // question_text:data.question_text,
          create_date: data.create_date,
        };

        rightfiltered_data.push(newdata);
      });
      this.rightfiltered_data = rightfiltered_data;
      //console.log("rightfiltered_data", rightfiltered_data);
      this.rightItems = [];
      this.rightItems = filtered_data;
    },
    selectnew() {
      this.selected_checked = [];
      var filtered_data = [];
      //console.log("!this.selectAll111", !this.selectAll);
      if (!this.selectAll) {
        for (let i in this.item_match.stat_ids) {
          this.selected_checked.push(this.item_match.stat_ids[i].id);
          this.isSelected = true;
        }
      }
      // //console.log("selected_checked", this.selected_checked);
      filtered_data = this.chackboxTable.filter((item, index) => {
        return this.selected_checked.includes(item.id);
      });
      // //console.log("filtered_data in select", filtered_data);
      var rightfiltered_data = [];
      filtered_data.forEach((data) => {
        var newdata = {
          answer: data.answer,
          answerlist: data.answerlist,
          uuid: data.uuid,
          quiz_id: data.quiz_id.name,
          question_text: data.question_text,
          create_date: data.create_date,
        };

        rightfiltered_data.push(newdata);
      });
      // this.rightfiltered_data = rightfiltered_data;
      //console.log("rightfiltered_data", rightfiltered_data);
      this.rightItems = [];
      this.rightItems = filtered_data;
    },

    async getQuizes() {
      const item_id = Number(this.$route.params.itemID);
      //console.log( "Number(this.$route.params.itemID) ::::: ", Number(this.$route.params.itemID), store.getters.getQuizes );
      var item_match = store.getters.getQuizes;
      var i_comenzados = 0;
      var i_answer = 0;
      var i_answerlist = [];
      item_match.forEach((item) => {
        if (item.id == item_id) {
          this.item_match = item;
          this.tempItemMatch = item;

          //console.log("item.stat_ids :::::::: ", item.stat_ids);
          this.chackboxTable = item.stat_ids;
          this.rightItems = item.stat_ids;
          this.rightItemsArray = item.stat_ids;
          item.stat_ids.forEach((i) => {
            if (i.uuid) {
              if (!this.uuid.includes(i.uuid)) {
                this.uuid.push(i.uuid);
                i_comenzados++;
              }
            }
            if (i.question_text && i.answer) {
              if (!this.buscar_respuestas_search.includes(i.answer)) {
                this.buscar_respuestas_search.push(i.answer);
                i_answer = i_answer + i.answer;
              }
            }
            // //console.log("i.answerlist ::::: ",i, i.answerlist);
            if (!i.answerlist == false) {
              i_answerlist.push(i.answerlist);
            }
            if (i.question_text) {
              if (!this.questionText.includes(i.question_text)) {
                this.questionText.push(i.question_text);
              }
            }
            if (!this.fecha.includes(i.create_date)) {
              this.fecha.push(i.create_date);
            }
          });
          this.comenzados = i_comenzados.toString();
          this.respuestas = i_answer.length.toString();
          this.completados = i_answerlist.length.toString();
        }
      });

      //console.log("item count result", this.buscar_respuestas_search);
    },

    async getcommenzadosCount(){
        var quiz_id = Number(this.$route.params.itemID);
        if(quiz_id !== ""){
          await store.dispatch("getcommenzadosCount",quiz_id).then(() => {
            var commenzadosCount = store.getters.getcommenzadosCount;
            //console.log("commenzadosCount::: ", commenzadosCount);
            var count = "0";
            if(commenzadosCount.length>0){
                commenzadosCount.forEach((data)=>{
                  //console.log("commenzadosCount::: ",typeof(quiz_id) , typeof(data.quiz_id[0].toString()), quiz_id === data.quiz_id[0].toString(), data.__count);
                    if(quiz_id === (data.quiz_id[0])){
                       count = data.__count; 
                    }
                });
              }
                //console.log("count in commenzados",count);
              this.comenzados = count.toString();
            return;
          });
        }
    },
    async getRespustasCount(){
        var quiz_id = Number(this.$route.params.itemID);
        if(quiz_id !== ""){
          await store.dispatch("getRespustasCount",quiz_id).then(() => {
            var respustasCount = store.getters.getRespustasCount;
            //console.log("respustasCount::: ", respustasCount);
            var count = "0";
            if(respustasCount !=undefined)
                count = respustasCount;

            this.respuestas = respustasCount.toString();
            return;
          });
        }
    },
    async getCompletadosCount(){
        var quiz_id = Number(this.$route.params.itemID);
        if(quiz_id !== ""){
          await store.dispatch("getCompletadosCount",quiz_id).then(() => {
            var completadosCount = store.getters.getCompletadosCount;
            //console.log("completadosCount::: ", completadosCount);
            var count = "0";
            if(completadosCount !=undefined)
                count = completadosCount;

            this.completados = completadosCount.toString();
            return;
          });
        }
    },
    async getRespustasData(){
        var quiz_id = Number(this.$route.params.itemID);
        var create_date=[];
        if (this.range !== null && this.range.length > 0){
          if(this.range[0] !== null){
            var start = moment(this.range[0]).format('YYYY-MM-DD');
            var end = moment(this.range[1]).format('YYYY-MM-DD');
            create_date.push(start);
            create_date.push(end);
          }
        }

        if(quiz_id !== ""){
          var payload = {
           "quiz_id":quiz_id,
           "create_date":create_date 
          }
          await store.dispatch("getRespustasData",payload).then(() => {
            var respustasData = store.getters.getRespustasData;
            //console.log("respustasData::: ", respustasData);
            // var count = "0";
            // if(respustasData.length > 0)
            //     count = respustasData;
            //console.log("store.getters.getRespustasData ::: ", store.getters.getRespustasData);
            this.leftItemCount = respustasData.length;

            this.leftItem = respustasData;
            this.leftItemArray = respustasData;
            return;
          });
        }
    },

    async getRespustasAnswerData(){
        var quiz_id = Number(Number(this.$route.params.itemID));
        //console.log("this.selecteduuids",this.selecteduuids);
        var uuid = this.selecteduuids;
        var create_date=[];

        if (this.range_ans !== null && this.range_ans.length > 0){
          if(this.range_ans[0] !== null){
            var start = moment(this.range_ans[0]).format('YYYY-MM-DD');
            var end = moment(this.range_ans[1]).format('YYYY-MM-DD');
            create_date.push(start);
            create_date.push(end);
          }
        }

        var params = {
          "quiz_ids" : quiz_id,
          "uuids" : uuid,
          "create_date":create_date 

        }
        //console.log("payload in answerdata:: ", params);
        if(quiz_id !== ""){
          await store.dispatch("getRespustasAnswerData",params).then(() => {
            var respustasAnswerData = store.getters.getrespustasAnswerData;
            //console.log("RespustasAnswerData::: ", store.getters.getrespustasAnswerData);
            // var count = "0";
            // if(respustasData.length > 0)
            //     count = respustasData;

            this.verifySelectedData = respustasAnswerData;

            return;
          });
        }
    },

    async getGraphdatabyQuiz(){
        var quiz_id = Number(this.$route.params.itemID);
        //console.log("quiz_ids111:::", quiz_id);
        var payload = {
            "value" : this.value,
            "quiz_id" : quiz_id
        };
        if(quiz_id !==""){
          await store.dispatch("getGraphdatabyQuiz",quiz_id).then(() => {
            var graphdatabyQuiz = store.getters.getGraphdatabyQuiz;
            //console.log("graphdatabyQuiz::: ", graphdatabyQuiz);
            this.graphdatabyQuiz = graphdatabyQuiz;
            this.renderedStatData = this.getQuizDataByDay(graphdatabyQuiz);
          });
        }
    },

    async getparaCompletar(){
        var quiz_id = Number(this.$route.params.itemID);
        if(quiz_id !== ""){
          await store.dispatch("getparaCompletar",quiz_id).then(() => {
            var paraCompletar = store.getters.getparaCompletar;
            //console.log("paraCompletar::: ", paraCompletar);
            var count = 0;
            var data = 0;
            var avg_time="00:00:00";
            var sum_time="00:00:00";
            
            if(paraCompletar.length>0){
                paraCompletar.forEach((data)=>{
                  count +=1;
                  //console.log("data::::", data.avg_time);
                  sum_time = moment.duration(sum_time).add(moment.duration(data.avg_time));
                })
                //console.log( "sum_time :: ", moment.utc(sum_time.as('milliseconds')).format("HH:mm:ss"), " ::: count ::", count);

                avg_time = moment.utc(sum_time.as('milliseconds')/count).format("HH:mm:ss");
            }
            
            // var avg_time1  = moment.utc(totalDurations.asMilliseconds()/count) ;
            this.tiempo_media_para_completar = avg_time.toString();
            return;
          });
        }
    },

    async getstatOverview() {
      //apache.quiz.stat_overview
      const item_id = Number(this.$route.params.itemID);
      //console.log("route_params_itemID ::::: ", Number(this.$route.params.itemID));
      var quiz_stat_overview = [];
      var i_comenzados = 0;
      var i_answer = 0;
      var i_answerlist = [];
      var payload = {
          "quiz_id":item_id,
          "graph_type":"Day"
      };
        this.isLoading = true;
        await store.dispatch("getstatOverview", payload).then(() => {
          quiz_stat_overview = store.getters.getstatOverview;
            //console.log( "quiz_stat_overview11 ::::::::: ", store.getters  );
          if (quiz_stat_overview.length > 0) {
            this.quizstatData = quiz_stat_overview;
          }
          else{
            this.quizstatData=[];

          }
          // return;
        });
        // //console.log("item count result", this.buscar_respuestas_search);
      // } else {
      //   this.quizstatData = quiz_stat_overview;
        //console.log("quiz_stat_overview :::::::::  ", quiz_stat_overview);
      // }

      this.renderedStatData = this.getQuizDataByDay(quiz_stat_overview);

    },
    async getstatOverviewMonth() {
      //apache.quiz.stat_overview
      const item_id = Number(this.$route.params.itemID);
      //console.log("route_params_itemID ::::: ", Number(this.$route.params.itemID));
      var quiz_stat_overview = [];
      var i_comenzados = 0;
      var i_answer = 0;
      var i_answerlist = [];
      var payload = {
          "quiz_id":item_id,
          "graph_type":"Month"
      };
        this.isLoading = true;
        await store.dispatch("getstatOverview", payload).then(() => {
          quiz_stat_overview = store.getters.getstatOverview;
            //console.log( "quiz_stat_overview11 ::::::::: ",  store.getters   );
          if (quiz_stat_overview.length > 0) {
            this.quizstatData_month = quiz_stat_overview;
          }
          else{
            this.quizstatData_month=[];

          }
          // return;
        });
        // //console.log("item count result", this.buscar_respuestas_search);
      // } else {
      //   this.quizstatData = quiz_stat_overview;
        //console.log("quiz_stat_overview :::::::::  ", quiz_stat_overview);
      // }

      // this.renderedStatData = this.getQuizDataByDay(quiz_stat_overview);

    },
    async getstatOverviewYear() {
      //apache.quiz.stat_overview
      const item_id = Number(this.$route.params.itemID);
      //console.log("route_params_itemID ::::: ", Number(this.$route.params.itemID));
      var quiz_stat_overview = [];
      var i_comenzados = 0;
      var i_answer = 0;
      var i_answerlist = [];
      var payload = {
          "quiz_id":item_id,
          "graph_type":"Year"
      };
        this.isLoading = true;
        await store.dispatch("getstatOverview", payload).then(() => {
          quiz_stat_overview = store.getters.getstatOverview;
            //console.log("quiz_stat_overview11 ::::::::: ",   store.getters  );
          if (quiz_stat_overview.length > 0) {
            this.quizstatData_year = quiz_stat_overview;
          }
          else{
            this.quizstatData_year=[];

          }
          // return;
        });
        // //console.log("item count result", this.buscar_respuestas_search);
      // } else {
      //   this.quizstatData = quiz_stat_overview;
        //console.log("quiz_stat_overview :::::::::  ", quiz_stat_overview);
      // }

      // this.renderedStatData = this.getQuizDataByDay(quiz_stat_overview);

    },

    onChangedateFilter() {
      var disp = this.range;
      this.leftItem=[];
      this.rightItems=[];
      this.getRespustasData()
      //console.log("this.selecteddateFilter ::::: ", this.range);
      // if (this.range === null) {
      //   this.leftItem = this.leftItemArray;
      // } else {
      //   var start = this.range[0];
      //   var end = this.range[1];

      //   this.leftItem = this.leftItemArray;
      //   if(this.leftItem.length>0){
      //     if (start !== null || end !== null) {
      //       //console.log("this.item_match before filter ::: ", this.leftItem.length);
      //       var filtered_data_item = this.leftItem.filter((item) => {
      //         return (
      //           moment(item.create_date) >= moment(start) &&
      //           moment(item.create_date) <= moment(end)
      //         );
      //       });
      //       var sorted_data = _.sortBy(filtered_data_item, "create_date");

      //       this.leftItem = sorted_data.reverse();
      //       //console.log("after filter filtered_data_item :::::::: ",filtered_data_item.length);
      //     } 
      //   }
      // }
    },
    dateSelected(date) {
      this.verifySelectedData=[];
      this.getRespustasAnswerData();
      // if (this.range[0] !== null || this.range[0] !== null) {
      //   var start = this.range[0];
      //   var end = this.range[1];
      //   var rightItems = this.rightItemsArray;
      //   if (rightItems.length > 0) {
      //     // //console.log("before filterinsight :::::::: ",gbareview);
      //     if (start !== null || end !== null) {
      //       var filtered_data = rightItems.filter((item) => {
      //         //console.log(
      //           "in filter date ::: ",
      //           moment(item.create_date) >= moment(start),
      //           moment(item.create_date) <= moment(end)
      //         );
      //         return (
      //           moment(item.create_date) >= moment(start) &&
      //           moment(item.create_date) <= moment(end)
      //         );
      //       });
      //       this.rightItems = filtered_data;
      //       //console.log("after filter gbareview :::::::: ", filtered_data);
      //     } else {
      //       this.rightItems = rightItems;
      //     }
      //   }
      // } else {
      //   this.rightItems = this.rightItemsArray;
      // }
    },
    onChangeuuidFilter() {
      var disp = this.selectuidfilter;
      this.item_match = this.tempItemMatch;
      var abc = [];
      var data = this.item_match;
      data.stat_ids.forEach((i) => {
        if (i.uuid == disp) {
          abc.push(i);
        }
      });
      this.chackboxTable = abc;
    },
    onChangequestionFilter() {
      this.selected_checked = [];
      var disp = this.selectquestionfilter;
      //console.log( this.selectquestionfilter, "============>",  this.chackboxTable.length   );
      if (this.selectquestionfilter === null) {
        this.item_match = this.tempItemMatch;
        this.chackboxTable = this.tempItemMatch.stat_ids;
      } else {
        this.item_match = this.tempItemMatch;
        var abc = [];
        var data = this.item_match;
        data.stat_ids.forEach((i) => {
          if (i.question_text == disp) {
            abc.push(i);
          }
        });
        this.chackboxTable = abc;
      }
    },
    onChange_buscar_respuestas() {
      var disp = this.select_buscar_respuestas;
      //console.log("display buscar_respuestas ==>", disp);
      if (this.select_buscar_respuestas === null) {
        this.item_match = this.tempItemMatch;
        this.chackboxTable = this.tempItemMatch.stat_ids;
        this.rightItems = this.rightItemsArray;
        // this.rightItemsArray = item.stat_ids;
      } else {
        this.item_match = this.tempItemMatch;
        var abc = [];
        var data = this.item_match;
        data.stat_ids.forEach((i) => {
          if (i.answer == disp) {
            abc.push(i);
          }
        });
        this.rightItems = abc;
      }
      // //console.log("display abc ==>", abc, "this.buscar_respuestas", this.fecha);
    },
    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },
    getMonthText(num) {
      switch (num) {
        case 1:
          return "Jan";
          break;
        case 2:
          return "Feb";
          break;
        case 3:
          return "Mar";
          break;
        case 4:
          return "Apr";
          break;
        case 5:
          return "May";
          break;
        case 6:
          return "Jun";
          break;
        case 7:
          return "Jul";
          break;
        case 8:
          return "Aug";
          break;
        case 9:
          return "Sep";
          break;
        case 10:
          return "Oct";
          break;
        case 11:
          return "Nov";
          break;
        case 12:
          return "Dec";
          break;

        default:
          break;
      }
    },
    getTimeFormat(hour) {
      if (hour >= 12) {
        return (hour == 12 ? hour : hour - 12) + ":00pm";
      } else {
        return (Math.floor(hour / 10) == 0 ? "0" + hour : hour) + ":00am";
      }
    },
    getDate(date) {
      var d = new Date(date);
      return d.toDateString();
    },
  },
};
</script>
<style scoped>
.active {
  background-color: lightgray;
}
.inactive {
  background-color: white;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>